export default "__VITE_ASSET__D2PvBMtC__"